import * as React from 'react';
import {Theme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import {Controller} from 'react-hook-form';
import {FormHelperText} from '@mui/material';
import get from 'lodash/get';
import {useEffect} from 'react';
import {useTheme} from '@emotion/react';

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 4;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP,
        },
    },
};

function getStyles(option: string, selectedValues: readonly string[], theme: Theme, entries: any) {
    return {
        fontWeight: !selectedValues?.find(r => r === get(option, entries[1]))
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
        backgroundColor: !selectedValues?.find(r => r === get(option, entries[1])) ? 'white' : '#f5f5f5',
    };
}

export default function InputMultipleSelect(props: any) {
    const theme = useTheme() as any;
    const {name, col, mb, label, form, options, entries} = props;
    const [selectedValues, setSelectedValues] = React.useState<string[]>([]);
    const {watch} = form;

    useEffect(() => {
        const selecteds = form.getValues([name][0])?.map((i: any) =>
            get(
                options?.find((r: any) => get(r, entries[0]) === i),
                entries[1],
            ),
        );
        setSelectedValues(selecteds);
    }, []);

    React.useEffect(() => {
        const subscription = watch((value: any, {name, type}: any) => {
            if (!type) {
                setSelectedValues([]);
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <Controller
            name={name}
            control={form.control}
            render={({field: {onChange, value, ...rest}, fieldState: {error, ...state}}: any) => {
                const hasError = !!error;
                return (
                    <FormControl sx={{width: '100%'}} error={hasError}>
                        <InputLabel size='small' id="demo-multiple-name-label">
                            {label}
                        </InputLabel>
                        <Select
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name-label"
                            multiple
                            size="small"
                            value={selectedValues}
                            onChange={(event: any, t: any) => {
                                const temp = event.target.value.map((r: any) =>
                                    typeof r === 'object' ? get(r, entries[1]) : r,
                                );

                                if (!selectedValues.find(r => r === get(t.props.value, entries[1]))) {
                                    setSelectedValues(temp);
                                    onChange([...value, get(t.props.value, entries[0])]);
                                } else {
                                    const cleared = selectedValues.filter(r => r !== get(t.props.value, entries[1]));
                                    const formClearedValue = value.filter(
                                        (r: any) => r !== get(t.props.value, entries[0]),
                                    );

                                    setSelectedValues(cleared);
                                    onChange(formClearedValue);
                                }
                            }}
                            input={<OutlinedInput size="small" id="select-multiple-chip" label={label} />}
                            renderValue={selected => (
                                <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                                    {selected.map((value, index) => (
                                        <Chip
                                            onClick={() => alert('adsşlfkj')}
                                            key={index}
                                            size="small"
                                            label={value}
                                        />
                                    ))}
                                </Box>
                            )}
                            MenuProps={MenuProps}
                        >
                            {options.map((option: any, index: number) => (
                                <MenuItem
                                    key={index}
                                    value={option}
                                    style={getStyles(option, selectedValues, theme, entries)}
                                >
                                    {get(option, entries[1])}
                                </MenuItem>
                            ))}
                        </Select>
                        {hasError && (
                            <FormHelperText sx={{color: theme.palette.error.main}}>{error.message}</FormHelperText>
                        )}
                    </FormControl>
                );
            }}
        ></Controller>
    );
}
